module.exports = __webpack_public_path__ + "static/media/login-bg.dc494030.png";